import React, { useState } from "react";
import MultiWeekPlannerToolbar from "./MultiWeekPlannerToolbar";
import MultiWeekSubnavigation from "./MultiWeekSubNavigation";
import DurationAggregator from "./DurationAggregator";
import moment from "moment";
import ScenarioSelectionModal from "./ScenarioSelectionModal";
import MultiWeekPlannerTabPicker from "./MultiWeekPlannerTabPicker";
import ViewSwitcher from "./ViewSwitcher";
import dashboardItems from "./dashboardTabs";
import {
  EVENT_PLANNING_SCENARIOS,
  USER_INFO,
  EVENT_PLANNING_USER_SELECTED_SCENARIOS,
} from "../../plannerConfig";
import { NoScenarioText } from "./styles";
import _ from "lodash";
import { GeneralFilter } from "../Filters";
import { appliedFilterForDashboard } from "../Filters/applyFilter";
import { ShowAppliedFilter } from "../Filters/ShowAppliedFilter";
import { Divider } from "antd";
import { mapGlobalFilterKeysToObj } from "../Filters";

const MultiWeekPlannerComponent = ({
  api,
  store,
  scenarioPreConfig,
  fromDate,
  toDate,
  filterData,
  history,
}) => {
  const { dashboardTabs, defaultActiveTab } = dashboardItems;
  const [[startDate, endDate], setDateRange] = useState([fromDate, toDate]);

  const [[fromDateFilter, toDateFilter], setDateFilterRange] = useState([
    fromDate,
    toDate,
  ]);

  const [appliedFilters, setAppliedFilters] = useState([]);

  const handleSetFilter = (filterSet) => {
    setAppliedFilters(filterSet);
  };

  const [durationAggregator, updateDurationAggregator] = useState("week");

  const returnTransformedSelectedScenarios = () => {
    if (!_.isEmpty(scenarioPreConfig)) {
      const { eventPlanningUserScenarios } = scenarioPreConfig;

      const transformInitialSelectedScenarios = () => {
        if (eventPlanningUserScenarios.length) {
          const scenarios = eventPlanningUserScenarios.map(
            ({ order, scenarioId, scenarioName, fromDate }) => {
              return {
                order,
                id: scenarioId,
                name: scenarioName,
                fromDate,
              };
            }
          );
          const orderedScenarios = _.orderBy(scenarios, ["order"], "asc");
          return orderedScenarios;
        }
        return [];
      };

      return transformInitialSelectedScenarios();
    }
    return [];
  };

  const [selectedScenarios, updateSelectedScenarios] = useState([
    ...returnTransformedSelectedScenarios(),
  ]);

  const [showScenarioSelectModal, toggleScenarioSelectVisibility] = useState(
    false
  );

  const currentUser = store[USER_INFO].data;

  const { data: multiWeekPlannerScenarioData } = store[
    EVENT_PLANNING_SCENARIOS
  ];

  const getPlannerScenarios = ({ fromDate, toDate }) => {
    const { get } = api;
    get([EVENT_PLANNING_SCENARIOS], {
      routeParams: { fromDate, toDate },
    });
  };

  const payloadDateFormat = "YYYY-MM-DD";

  const [activeDashboard, setActiveDashboard] = useState(defaultActiveTab);

  const returnRequestPayload = () => {
    const buildScenarioObject = selectedScenarios
      ? []
      : selectedScenarios.map((scenario) => {
          return {
            scenario: scenario.id,
          };
        });

    return {
      user: currentUser.id,
      from_date: moment(startDate).format(payloadDateFormat),
      to_date: moment(endDate).format(payloadDateFormat),
      event_planning_user_scenarios: buildScenarioObject,
      ...mapGlobalFilterKeysToObj(appliedFilters),
    };
  };

  const handlePostUserSelectedScenarios = (scenarios) => {
    const { post } = api;
    post([EVENT_PLANNING_USER_SELECTED_SCENARIOS], {
      body: returnRequestPayload(scenarios),
    });
  };

  const handleToggleScenarioVisibility = () => {
    toggleScenarioSelectVisibility((prev) => {
      return !prev;
    });

    getPlannerScenarios({
      fromDate: startDate.format(payloadDateFormat),
      toDate: endDate.format(payloadDateFormat),
    });
  };

  const buildSelectedScenariosString = (selectedScenarios) =>
    selectedScenarios.map((scenario) => `scenario_id=${scenario.id}`).join("&");

  return (
    <>
      <MultiWeekSubnavigation
        openScenarioSelectModal={handleToggleScenarioVisibility}
        startDate={startDate}
        endDate={endDate}
        setDateRange={setDateRange}
        onClick={() => alert("hello")}
        selectedScenarios={selectedScenarios}
        fromDateFilter={fromDateFilter}
        toDateFilter={toDateFilter}
        setDateFilterRange={setDateFilterRange}
        history={history}
      />
      <MultiWeekPlannerToolbar
        leftComponent={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              flex: 1,
              alignItems: "center",
            }}
          >
            <GeneralFilter
              {...filterData}
              filterObj={filterData}
              onVisibilityChange={() => {}}
              onGlobalChange={setAppliedFilters}
              onKpiChange={() => {}}
              disabled={false}
              globalFilterApplied={appliedFilters}
              kpiFilterApplied={[]}
              onClickToApplyFilter={handleSetFilter}
            />
            <ShowAppliedFilter
              globalFilterApplied={appliedFilters}
              hideView={false}
              filterObj={filterData}
              kpiFilterApplied={[]}
            />
          </div>
        }
        rightComponent={
          <DurationAggregator
            selection={durationAggregator}
            onChange={(event) => {
              updateDurationAggregator(event.target.value);
            }}
          />
        }
      >
        {selectedScenarios.length ? (
          <ViewSwitcher
            activeViewKey={activeDashboard.title}
            updateDurationAggregator={updateDurationAggregator}
            api={api}
            fromDate={moment(startDate).format(payloadDateFormat)}
            toDate={moment(endDate).format(payloadDateFormat)}
            store={store}
            requestPayload={returnRequestPayload()}
            selectedScenarios={selectedScenarios}
            fromDateFilter={moment(fromDateFilter).format(payloadDateFormat)}
            toDateFilter={moment(toDateFilter).format(payloadDateFormat)}
            durationAggregator={durationAggregator}
            scenarioStringBuilder={buildSelectedScenariosString}
            appliedFilterForDashboard={appliedFilterForDashboard}
            filterData={{ ...filterData.globalFilter.list }}
            activeFrontendFilters={appliedFilters}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <NoScenarioText color="greyscale.9">
              No Scenarios Selected
            </NoScenarioText>
          </div>
        )}

        <MultiWeekPlannerTabPicker
          dashboards={dashboardTabs}
          activeDashboard={activeDashboard}
          setActiveDashboard={setActiveDashboard}
          disableDashCreation
        />
      </MultiWeekPlannerToolbar>
      <ScenarioSelectionModal
        visible={showScenarioSelectModal}
        onCancel={handleToggleScenarioVisibility}
        destroyOnClose
        scenarios={multiWeekPlannerScenarioData}
        selectedScenarios={selectedScenarios}
        updateSelectedScenarios={updateSelectedScenarios}
        onConfirm={handlePostUserSelectedScenarios}
        store={store}
        api={api}
        fromDate={moment(startDate).format(payloadDateFormat)}
        toDate={moment(endDate).format(payloadDateFormat)}
      />
    </>
  );
};

export default MultiWeekPlannerComponent;
